export default __webpack_public_path__ + "static/media/indianflag.c76c2704.png";